/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentResponse
 */
export interface EquipmentResponse {
    /**
     * 
     * @type {number}
     * @memberof EquipmentResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentResponse
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof EquipmentResponse
     */
    assetId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentResponse
     */
    mineLocationId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentResponse
     */
    equipmentTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentResponse
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof EquipmentResponse
     */
    installDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof EquipmentResponse
     */
    manufacturerId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentResponse
     */
    configurationId?: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentResponse
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentResponse
     */
    partNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentResponse
     */
    capitalIndexNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof EquipmentResponse
     */
    effectiveDate?: Date;
}

/**
 * Check if a given object implements the EquipmentResponse interface.
 */
export function instanceOfEquipmentResponse(value: object): value is EquipmentResponse {
    return true;
}

export function EquipmentResponseFromJSON(json: any): EquipmentResponse {
    return EquipmentResponseFromJSONTyped(json, false);
}

export function EquipmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'mineLocationId': json['mineLocationId'] == null ? undefined : json['mineLocationId'],
        'equipmentTypeId': json['equipmentTypeId'] == null ? undefined : json['equipmentTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'installDate': json['installDate'] == null ? undefined : (new Date(json['installDate'])),
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'configurationId': json['configurationId'] == null ? undefined : json['configurationId'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'capitalIndexNumber': json['capitalIndexNumber'] == null ? undefined : json['capitalIndexNumber'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
    };
}

export function EquipmentResponseToJSON(json: any): EquipmentResponse {
    return EquipmentResponseToJSONTyped(json, false);
}

export function EquipmentResponseToJSONTyped(value?: EquipmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'assetId': value['assetId'],
        'mineLocationId': value['mineLocationId'],
        'equipmentTypeId': value['equipmentTypeId'],
        'name': value['name'],
        'description': value['description'],
        'installDate': value['installDate'] == null ? undefined : ((value['installDate']).toISOString().substring(0,10)),
        'manufacturerId': value['manufacturerId'],
        'configurationId': value['configurationId'],
        'serialNumber': value['serialNumber'],
        'partNumber': value['partNumber'],
        'capitalIndexNumber': value['capitalIndexNumber'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString().substring(0,10)),
    };
}

